/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maple_Flat_Quail_PlanInputs */

const en_maple_flat_quail_plan = /** @type {(inputs: Maple_Flat_Quail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Attributes`)
};

const de_maple_flat_quail_plan = /** @type {(inputs: Maple_Flat_Quail_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale`)
};

/**
* | output |
* | --- |
* | "Member Attributes" |
*
* @param {Maple_Flat_Quail_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const maple_flat_quail_plan = /** @type {((inputs?: Maple_Flat_Quail_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maple_Flat_Quail_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maple_flat_quail_plan(inputs)
	return de_maple_flat_quail_plan(inputs)
});